import React from 'react';

export default function Bar(props) {
  const { group, partiallyPerc, fullyPerc, boostersPerc } = props;
  console.log('props ', props);

  const noVaxStyle = {
    width: '100%',
  };

  const singleBarStyle = {
    width: `${partiallyPerc}%`,
  };

  const doubleBarStyle = {
    width: `${fullyPerc}%`,
  };

  const boosterBarStyle = {
    width: `${boostersPerc}%`,
  };

  const unVaxStyle = {
    width: `calc(100% - ${partiallyPerc}%)`,
    left: `${partiallyPerc}%`,
  };

  const unVaxPerc = (100 - partiallyPerc).toFixed(1);

  return (
    <div className="details-wrap">
      <div className="groupName">{group}</div>
      <div className="bar-wrap">
        <div className="no-vax" style={noVaxStyle} />
        <div className="single-bar" style={singleBarStyle} />
        <div className="double-bar" style={doubleBarStyle} />
        <div className="booster-bar" style={boosterBarStyle} />
        <div className="unvacVal" style={unVaxStyle}>
          {unVaxPerc}%
        </div>
      </div>
    </div>
  );
}
